import { appConfig } from 'brand-config';

export const isPolicyDraftingSupported = () => Boolean(appConfig?.featureFlags?.policyDrafts);

export const isDraftablePolicyType = (policyType) =>
  Boolean(policyType && appConfig?.draftablePolicyTypes?.includes(policyType));

export const supportsEndorsementDrafts = (policyType) =>
  isPolicyDraftingSupported() && isDraftablePolicyType(policyType);
